import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser((prev) => (prev ? prev : r.data)))
      .catch(() => setUser((prev) => (prev ? prev : false)))
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password, code, rememberDevice) => {
    const { data } = await api.post("/auth/login", { email, password, code, remember_device: !!rememberDevice });
    if (data && data.two_factor_required) return data;
    setUser(data);
    return data;
  };
  const logout = async () => {
    // Best-effort server-side token revocation. A user must ALWAYS be able to log out
    // locally even if this call fails (e.g. expired CSRF cookie -> 403), so never throw.
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.warn("Logout request failed; clearing local session anyway.", e?.response?.status);
    } finally {
      setUser(false);
    }
  };

  return <AuthContext.Provider value={{ user, setUser, login, logout, checking }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  const loc = useLocation();
  if (checking || user === null)
    return <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  return children;
}
